function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.9555556,43.4542636 C13.1867165,43.4542636 4.45684755,34.7243946 4.45684755,23.9555556 C4.45684755,13.1867165 13.1867165,4.45684755 23.9555556,4.45684755 C34.7243946,4.45684755 43.4542636,13.1867165 43.4542636,23.9555556 C43.4542636,34.7243946 34.7243946,43.4542636 23.9555556,43.4542636 Z M13.2998527,36.0556252 L17.8680726,30.9536367 C17.833348,32.2870233 18.3886624,33.6223139 19.4977981,34.5455392 C21.4314286,36.1550595 24.3160773,35.9026855 25.9408414,33.9818459 L39.3849663,18.9668571 C38.4256585,15.8520078 36.557973,13.172838 34.112273,11.2065728 L28.7545411,17.1903229 C28.7892657,15.8569363 28.2339513,14.5216457 27.1248156,13.5984204 C25.1911851,11.9889001 22.3065364,12.2412741 20.6817723,14.1621137 L8.31470793,27.974194 C9.13806889,31.1848401 10.9130073,33.9736623 13.2998527,36.0556252 L13.2998527,36.0556252 Z",
  id: "Shape",
  fill: "#1B3C6B",
  fillRule: "nonzero"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.84bb8609.svg";
export { ForwardRef as ReactComponent };